import React from 'react';
import { Card, Typography } from 'antd';

const { Title } = Typography;

const ActivityCodeList = () => {
  return (
    <div>
      <Card>
        <Title level={2}>活動序號列表</Title>
        <p>活動序號列表功能開發中...</p>
      </Card>
    </div>
  );
};

export default ActivityCodeList;
